import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import Icon from "./Icon";

class ActiveFilters extends Component {

  render() {

    let filterLabels = [];
    Object.keys(this.props.filterObjects).map((filterName) => {
      if (filterName === 'field_sustainable') {
        let filter_label = '';
        if (filterName === 'field_sustainable') {
          filter_label = this.props.t('active_filters.filter_label_sustainable', 'Sustainable');
        }
        filterLabels.push(
          <li className="active-filters__item">
            <button onClick={(event) => {event.preventDefault();this.props.removeFilter(filterName, filterValue)}} className="active-filter">
              {filter_label}
              <Icon iconId="cross-light" />
            </button>
          </li>
        )
      } else if (filterName === 'field_search') {
      } else if (filterName === 'field_capacity') {
        if (this.props.filterObjects[filterName].min) {
/* Disabled because active slider label reset won't work right
          filterLabels.push(
            <li className="active-filters__item">
              <button onClick={(event) => {event.preventDefault();this.props.removeFilter(filterName, 0)}} className="active-filter">
                Capacity {this.props.filterObjects[filterName].min} - {this.props.filterObjects[filterName].max}
              </button>
            </li>
          );
*/
        }
      } else {
        this.props.filterObjects[filterName].map((filterValue) => {
          filterLabels.push(
            <li className="active-filters__item">
              <button onClick={(event) => {event.preventDefault();this.props.removeFilter(filterName, filterValue)}} className="active-filter">
                {this.props.filterLabels[filterName + '_' + filterValue]}
                <Icon iconId="cross-light" />
              </button>
            </li>
          );
        });
      }
    });

    let removeAllFilters = null;
    if (filterLabels.length > 0) {
      removeAllFilters = (
          <button onClick={(event) => {this.props.removeAllFilters();event.preventDefault();}} className="active-filter">
            <Trans i18nKey="active_filters.filter_label_remove_all">Remove all filters</Trans>
            <Icon iconId="cross-light" />
          </button>
      );
    }

    return (
      <div className="active-filters">
        {removeAllFilters}
        <ul className="active-filters__items">
          {filterLabels}
        </ul>
      </div>
    );
  }
}

export default withTranslation()(ActiveFilters);
